<template>
    <div class="main">
        <header>
            <a class="header_logo" href="https://www.ubiquitous-p.com/">
                <img src="../assets/logo.jpg">
            </a>
            <div class="header_right">
                <router-link class="header_link" to="/ubiadmin/AdminStaffList">スタッフー覧</router-link>
                <router-link class="header_link" to="/ubiadmin/AdminNewsList">ニュース一覧/編集</router-link>
                <p>{{$store.state.userName}}</p>
                <button class="logout_btn" v-on:click="logout">ログアウト</button>
            </div>
        </header>
        <form class="container" v-on:submit="$router.push('/ubiadmin/AdminNewsConfirm2')">
            <h3 v-show="err_catch" class="err_msg">エラー発生!!!!</h3>
            <h1>ニュース登録</h1>
            <p class="title_txt">スタッフへ配信するニュースを登録または、編集してください。</p>
            <div class="admin_news_edit_wrap">
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>タイトル</p>
                        <input v-model="news.notice_title" placeholder="タイトルを入力してください。" maxlength="50" type="text" required />
                    </div>
                    <p class="input_txt">※50文字以内で入力してください。</p>
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>本文</p>
                        <textarea v-model="news.notice_text" placeholder="本文を入力してください。" maxlength="250" type="text" required ref="area" :style="styles"></textarea>
                    </div>
                    <p class="input_txt">※250文字以内で入力してください。</p>
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>添付ファイル</p>
                        <input placeholder="DFまたは、MP4ファイル" accept=".mp4,.pdf" type="file" class="file" readonly name="file" v-on:change="fileSelected">
                    </div>
                    <p class="input_txt">※PDFまたは、MP4ファイルを選択してください。</p>
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p></p>
                        <div class="preview" v-if="!!news.file_data.mp4 == true">
                            <video controls controlsList="nodownload" oncontextmenu="return false;" v-bind:src="news.file_data.mp4"></video>
                        </div>
                        <div class="preview" v-if="!!news.file_data.pdf == true">
                            <iframe width="100%" height="100%" v-bind:src="news.file_data.pdf"></iframe>
                        </div>
                    </div>
                </div>
                <div class="delivery_date_box">
                    <p>ニュース配信予約日時</p>
                    <input v-bind:value="news.post_date | dateFormat" v-on:input="inputEvent" type="datetime-local" required />
                </div>
                <div class="news_edit_wrap">
                    <div class="news_edit_box">
                        <p>メール送信用定型文</p>
                        <textarea v-model="news.template" placeholder="メール送信用定型文を入力してください。" maxlength="250" type="text" required ref="area" :style="styles"></textarea>
                    </div>
                    <p class="input_txt">※250文字以内で入力してください。</p>
                </div>
            </div>
            <div class="news_edit_btns">
                <router-link :to="{name: 'AdminNewsList'}">戻る</router-link>
                <div class="news_edit_right_btns">
                    <button class="red_btn" v-on:click="delte_notice">削除</button>
                    <button class="green_btn" v-on:click="fileUpload">内容確認</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
export default {
    data () {
        return {
            fileInfo: '',
            err_catch: false,
            news_data: '',
            news_files:'',
            news_filename:'',
            url_protcol: 'https://',
            domain: '1304kanri.ubiquitous-p.com',
            url_mount_path: '/rest/get_notice_detail/',
            url_delete_path: '/rest/delete_notice/',
            url_upload_path: '/rest/upload_file/',
            height: "100px"
        }
    },
    mounted () {
        this.axios
        .post(this.url_protcol + this.domain + this.url_mount_path + this.$route.query.id + '/',{},{
            headers: {
                    "Content-Type": "application/json", 
                    "Authorization": this.$store.state.userToken 
                }
        })
        .then(response => {
            this.news_data = response.data
            this.news.notice_title = this.news_data.title
            this.news.notice_text = this.news_data.body
            this.news.post_date = this.news_data.post_date
            this.news.notice_id = this.news_data.notice_id
            this.news_files = {"mp4":this.news_data.attach_file_mp4,"pdf":this.news_data.attach_file_pdf,"file_name":""}
            this.news.file_data = this.news_files
            this.news.template = this.news_data.template
        }),
        this.resize();
    },
    filters: {
        dateFormat: function (value) {
        if (value !== '') {
            return moment(value).format('YYYY-MM-DDTHH:mm')
        }
        }
    },
    props: {
        news: Object
    },
    methods: {
        delte_notice (event) {
            if (confirm("このニュースを削除しますか")){
                this.axios
                .post(this.url_protcol + this.domain + this.url_delete_path + this.$route.query.id + '/',{},{
                    headers: {
                            "Content-Type": "application/json", 
                            "Authorization": this.$store.state.userToken 
                        }
                })
                .then(response => {
                this.$router.push({name: 'AdminNewsList'})
                })
                .catch(error => {
                // エラー処理
                this.err_catch = true
                console.log(error)
                })
            }else{
                event.preventDefault()
            }
        },
        fileSelected (event) {
            this.fileInfo = event.target.files[0]
        },
        fileUpload () {
            const formData = new FormData()
            formData.append('file', this.fileInfo)
            axios.post(this.url_protcol + this.domain + this.url_upload_path, formData,{
                headers: {
                            "Content-Type": "application/json", 
                            "Authorization": this.$store.state.userToken 
                        }
            }).then(response => {
                if(Object.keys(response.data).length){
                    this.news.file_data = response.data
                }else{
                    if(this.news.file_data.mp4 != ''){
                        this.news_filename = this.news.file_data.mp4.split("/")
                        this.news.file_data.file_name = this.news_filename[this.news_filename.length - 1]
                    }else if(this.news.file_data.pdf != ''){
                        this.news_filename = this.news.file_data.pdf.split("/")
                        this.news.file_data.file_name = this.news_filename[this.news_filename.length - 1]
                    }
                }
            }).catch(error => {
                this.err_catch = true
                console.log(error)
            })
        },
        inputEvent (event) {
            this.news.post_date = event.target.value
        },
        logout() {
            this.$store.commit('reset')
            this.$router.push({name:'aLogin'})
        },
        resize(){
            this.height = "100px";
            this.$nextTick(()=>{
            this.height = this.$refs.area.scrollHeight + 'px'
            })
        }
    },
    computed:{
        styles(){
            return {
                "height": this.height
            }
        }
    },
    watch:{
        news: {
            handler: function(){
                this.resize()
            },
            deep: true
        }        
    }
}
</script>

<style scoped>
.preview {
    width: 100%;
}

.preview video {
    width: 100%;
    height: 420px;
}

iframe[src$=".pdf"]{
    width: 100%;
    height: 80vw;
}

.main {
    width: 100vw;
    height: 100vh;
    background-size: cover;
}

.container {
    width: 100vw;
    height: 93vh;
}

h1 {
    margin: 10px 30px;
}

p.title_txt {
    margin: 10px 30px;
}

.admin_news_edit_wrap {
    width: 90vw;
    margin: 0 auto;
    background-color: rgba(255, 255, 255, 0.6);
    box-shadow: rgb(228 228 228) 1px 1px 8px;
    padding: 30px 80px;
}

.news_edit_wrap {
    width: 70%;
    margin-top: 40px;
}

.news_edit_wrap:nth-child(4) {
    width: 100%;
}

p.input_txt {
    color: #FF0202;
    font-size: .8em;
    text-align: right;
    margin-right: 20px;
}

.news_edit_box {
    display: flex;
    position: relative;
}

.news_edit_box p {
    width: 150px;
    line-height: 40px;
}

input, textarea {
    display: block;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid #888;
    box-shadow: rgb(210 210 210) 1px 1px 3px inset;
}

input.file {
    line-height: 37.5px;
}

textarea {
    resize: none;
    height: 100px;
    padding-top: 10px;
}

.delivery_date_box {
    border-top: 1px solid;
    margin-top: 30px;
    padding-top: 20px;
}

.delivery_date_box input {
    width: 60%;
}

a.choise_btn {
    display: block;
    width: 80px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background-color: #D7E37D;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    position: absolute;
    right: 20px;
}

.news_edit_btns {
    display: flex;
    justify-content: space-between;
    width: 90vw;
    margin: 0 auto;
    padding: 15px;
}

button.red_btn, button.green_btn, .news_edit_btns a {
    display: block;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #4DC0AD;
    color: #fff;
    text-decoration: none;
    border-radius: 15px;
    margin: 5px 0;
    border: none;
    font-size: inherit;
}

button.red_btn {
    background-color: #F37B6F;
    border: none;
    margin-right: 30px;
}

.news_edit_right_btns {
    display: flex;
}

.err_msg {
    color: red;
    text-align: center;
}

iframe[src$=".pdf"]{
    width:100%;
    height:80vh;
}    


</style>



// WEBPACK FOOTER //
// src/components/AdminNewsEdit2.vue